export const Stack = ({ children, gap = 28 }) => (
  <div style={{ display: "flex", flexDirection: "column", gap }}>{children}</div>
);
